// @flow

export function getTruncatedString (val: string, len: number) : string {
  // enforce valid inputs
  if (typeof val === 'number' ||
    typeof val === 'object' ||
    typeof val === 'function' ||
    typeof len !== 'number') {
    return ''
  }

  const truncatedString = val || ''
  return truncatedString.length < (len + 1)
    ? truncatedString
    : truncatedString.substring(0, (len - 1)) + ' ...'
}

export function isValidEmailAddress (email: string) : boolean {
  email = email.trim()
  const atIndex = email.indexOf('@')
  return atIndex > 0 && email.length > (atIndex + 1)
}

// TODO: this is taken from QM, improve the regex so it doesn't allow things like 'asdfhttps://'
export const isValidUrl = url => {
  return /(http(s?))\:\/\//gi.test(url)
}

export const pluralizeString = ({ count, singular, plural }) => {
  if (count === 1 || count === '1') {
    return singular
  }
  return plural
}

// A; A and B; A, B, and C
export const oxfordCommaJoin = arr => {
  switch (arr.length) {
    case 0: return ''
    case 1: return arr[0]
    case 2: return arr.join(' and ')
    default: return `${arr.slice(0, -1).join(', ')}, and ${arr[arr.length - 1]}`
  }
}

// Note: this is not perfect (HTML is context free not regular so it can't be)
// It's oversimplied but good enough for desired use cases
// Basically this is just checking to make sure there are non-whitespace
// characters between tags (or really just anything between a '>' and a '<')
// &nbsp; is considered whitespace in this context
const htmlTextContentRegex = />(?:\s|&nbsp;)*(?:[^<>\s&]|&(?!nbsp;))[^<>]*</i
export const htmlHasTextContent = html =>
  htmlTextContentRegex.test(html)

// strips any leading or trailing tags that have only whitespace content
// IMPORTANT: this does not handle nesting, only top-level tags
// &nbsp; and <br/> are considered whitespace
const br = 'br\\s*/?'
const whitespace = `(?:\\s|<${br}>|&(?:nbsp|ensp|emsp|#32);)`
const element = `<(?!(/|${br}>))[^>]*(?:/>|>${whitespace}*</[^>]*>)`
const chunk = `(?:${whitespace}|${element})+`
const leadingTrailing = `^${chunk}|${chunk}\$`

const escaped = leadingTrailing.replace(/\//g, '\\$&')
const leadingTrailingWhiteRegex = new RegExp(escaped, 'g')
export const stripHtmlEmptyTags = html =>
  html.replace(leadingTrailingWhiteRegex, '')
